import "./Gameplay.scss";

const steps = [
  [
    "Recruit Warriors",
    "Choose cards from the open market and prepare for the buildings you want to conquer next.",
    "cards.webp"
  ],
  [
    "Conquer a Building",
    "Match the warrior requirement, place your flag, and claim prestige on the board.",
    "flags.webp"
  ],
  [
    "Gain a Resource",
    "Take the resource from that territory and save its special ability for the right moment.",
    "gain_resource.webp"
  ],
  [
    "Build Momentum",
    "Use your flags, resources, and connected buildings to create stronger future turns.",
    "player_flags.webp"
  ]
];

export default function Gameplay() {
  return (
    <section className="gameplay section" id="gameplay">
      <div className="section-header">
        <span className="section-eyebrow">Simple turns</span>
        <h2 className="section-title">Recruit or Conquer.</h2>
        <p className="section-copy">
          On your turn, choose one action: recruit warriors or conquer a building. The rules are easy to understand, but every decision affects your future influence, resources, and scoring opportunities.
        </p>
      </div>

      <div className="gameplay__steps">
        {steps.map(([title, copy, file]) => (
          <article className="gameplay__step card" key={title}>
            <div className="gameplay__image" style={{ backgroundImage: `url('/assets/images/${file}')` }}>
              {/* <div className="gameplay__image-label">{title}</div> */}
            </div>
            <h3>{title}</h3>
            <p>{copy}</p>
          </article>
        ))}
      </div>
    </section>
  );
}
